module.exports = __webpack_public_path__ + "static/media/tomas_jicha.0d1b381c.jpg";